
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";

interface StrategyNotFoundProps {
  filters?: any;
}

const StrategyNotFound = ({ filters }: StrategyNotFoundProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-[#F5F7FB]">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600">
            Strategy information not found
          </h1>
          <Button onClick={() => navigate('/marketplace', { state: { filters } })} className="mt-4">
            Return to Marketplace
          </Button>
        </div>
      </main>
    </div>
  );
};

export default StrategyNotFound;
